module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><circle cx=\"9\" cy=\"9\" r=\"9\" fill=\"#836AB5\"></circle><path fill=\"#FFF\" d=\"M9.564 8.86H8.298c-.046 0-.064-.024-.056-.072l.34-2.075c.008-.048.034-.073.08-.073h1.266c.7 0 1.045.45.936 1.116-.11.668-.6 1.105-1.3 1.105zM7.38 13.35c.067 0 .12-.048.133-.121l.451-2.754c.008-.05.035-.073.08-.073h1.368c1.662 0 2.858-1.093 3.112-2.646.259-1.576-.57-2.656-2.243-2.656H7.298c-.067 0-.12.048-.133.121L5.852 13.23c-.012.073.025.121.093.121h1.436z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./_src/svg/grade.svg
// module id = 3
// module chunks = 0